  import { defineComponent, type PropType } from "vue";
  import CiviliteSelect from '@/extend/controls/civilite/CiviliteSelect';
  import ContactMail from '@/extend/controls/contact/ContactMail';
  import ContactNom from '@/extend/controls/contact/ContactNom';
  import ContactNumero from '@/extend/controls/contact/ContactNumero';
  import ContactPrenom from '@/extend/controls/contact/ContactPrenom';
  import QualiteSelect from '@/extend/controls/qualite/QualiteSelect';
  import Contact from '@/extend/classes/Contact';
  import { FieldStatus, EditFieldTheme, SectionStatus } from '@/framework/base/components/FieldInfo';
  import { Alerts } from '@/framework/base/helpers/Alerts'; 
  import { storeContact } from '@/generated/stores';
  import LoaderButton from '@/framework/base/components/LoaderButton.vue';
  import SectionHeader from '@/framework/base/components/SectionHeader.vue';
  import { Extended } from '@/framework/base/classes/Schema';
  import ButtonPlus from '@/framework/base/components/ButtonPlus.vue';
  import Route from '@/generated/classes/Route';
  import { Fiches, Sections } from '@/generated/classes/AppSchema';
  import { ObjTypes } from '@/generated/classes/ObjTypes';
  export default defineComponent({
    components: {
      SectionHeader,
      LoaderButton,
      ButtonPlus,
      CiviliteSelect,
      ContactMail,
      ContactNom,
      ContactNumero,
      ContactPrenom,
      QualiteSelect,
    },

    props: {
      contact: {
        type: Object as PropType<Contact>,
        required: true
      },
      showButton: {
        type: Boolean,
      },
      autoSave: {
        type: Boolean,
      },
      fieldOnly: {
        type: Boolean,
      },
      extended: {
        type: Boolean,
      },
      autoClear: {
        type: Boolean,
      },
      dialog: {
        type: Boolean,
      },
      closeSection: {
        type: Boolean,
      },
      showMissing: {
        type: Boolean,
      },
      moduleId: {
        type: Number,
      },
      theme: {
        type: Object as PropType<EditFieldTheme>,
      },
      fiche: {
        type: String,
      },
      fromSection: {
        type: String,
      },
      requiredAttributs: {
        type: Array as PropType<string[]>,
      },
      toggleResetCiviliteSelect: {
        type: Boolean
      },
      toggleResetQualiteSelect: {
        type: Boolean
      },
    },

    beforeUnmount (): void {
      if (!this.closeSection) {
        this.beforeClose();
      }
    },

    data() {
      return {
    toggleCiviliteId: false,
        civiliteIdStatus: new FieldStatus(false, false, 0),
        strCiviliteId: '',
        mailStatus: new FieldStatus(false, false, 0),
        strMail: '',
        nomStatus: new FieldStatus(false, false, 0),
        strNom: '',
        numeroStatus: new FieldStatus(false, false, 0),
        strNumero: '',
        prenomStatus: new FieldStatus(false, false, 0),
        strPrenom: '',
    toggleQualiteId: false,
        qualiteIdStatus: new FieldStatus(false, false, 0),
        strQualiteId: '',
        refContact: new Contact,
        cloneContact: new Contact,
      contactSaving: false,
        saving: false,
        restoring: false,
        inDialog: false,
        updated: false,
        error: false,
        saveLoading: false,
        saveFailed: false,
        allowClearRef: true,
        objType: ObjTypes.CONTACT,
        status: new SectionStatus(false, false, false),
        autoClose: true,
        closing: false
      }
    },
    computed: {
      isExtended (): boolean {
        return this.extended;
      },

      exist (): boolean {
        return this.editContact.id != 0
      },

      extendIcon (): string {
        return this.extended ? 'fas fa-circle-minus' : 'fas fa-circle-plus';
      },

      saveButton (): boolean {
        return (this.showButton == undefined || this.showButton == true) && !this.allReadOnly;
      },

      editContact: {
        get(): Contact {
          if (this.closeSection) {
            this.beforeClose();
          } else {
            if (this.contact != undefined) {
              if (this.contact.id == 0) {
                Alerts.debug('CrudContact : les objets passés en paramètre doivent être issus du store (id <> 0)');
              }
              if (this.cloneContact.id != this.contact.id && !this.saving) {
                this.handleContactChange();
              }
            }
          }
          return this.refContact;
        },
        set(value: Contact) {
          this.refContact = value;
        }
      },

      canCreate (): boolean {
        return this.refContact.id > 0;
      },

      canDelete (): boolean {
        return this.refContact.canDelete && this.refContact.id > 0;
      },

      updatedAndValid (): boolean {
        return this.updated && !this.error;
      },

      clearAuto (): boolean {
        return (this.autoClear == undefined || this.autoClear == true) && this.allowClearRef;
      },

    resetCiviliteId (): boolean {
      return this.toggleCiviliteId
    },

      civiliteId: {
        get(): number {
          return this.editContact.civiliteId;
        },
        set(value: number) {
          this.editContact.civiliteId = value;
          this.fieldUpdated('CIVILITE_ID', value);
        }
      },


      mail: {
        get(): string {
          return this.editContact.mail;
        },
        set(value: string) {
          this.editContact.mail = value;
          this.fieldUpdated('MAIL', value);
        }
      },


      nom: {
        get(): string {
          return this.editContact.nom;
        },
        set(value: string) {
          this.editContact.nom = value;
          this.fieldUpdated('NOM', value);
        }
      },


      numero: {
        get(): string {
          return this.editContact.numero;
        },
        set(value: string) {
          this.editContact.numero = value;
          this.fieldUpdated('NUMERO', value);
        }
      },


      prenom: {
        get(): string {
          return this.editContact.prenom;
        },
        set(value: string) {
          this.editContact.prenom = value;
          this.fieldUpdated('PRENOM', value);
        }
      },

    resetQualiteId (): boolean {
      return this.toggleQualiteId
    },

      qualiteId: {
        get(): number {
          return this.editContact.qualiteId;
        },
        set(value: number) {
          this.editContact.qualiteId = value;
          this.fieldUpdated('QUALITE_ID', value);
        }
      },


      allReadOnly (): boolean {
        const res = this.contact.canUpdate && (
        (this.isDisplayed('CIVILITE_ID') && !this.readOnly('CIVILITE_ID')) ||
        (this.isDisplayed('MAIL') && !this.readOnly('MAIL')) ||
        (this.isDisplayed('NOM') && !this.readOnly('NOM')) ||
        (this.isDisplayed('NUMERO') && !this.readOnly('NUMERO')) ||
        (this.isDisplayed('PRENOM') && !this.readOnly('PRENOM')) ||
        (this.isDisplayed('QUALITE_ID') && !this.readOnly('QUALITE_ID')));
        return !res;
      },

      fields (): string[] {
        return ['CIVILITE_ID', 'MAIL', 'NOM', 'NUMERO', 'PRENOM', 'QUALITE_ID'];
      },
    },

    methods: {
      handleContactChange() : void {
        // Edited object changed
        this.saveFailed = false;
        if (this.autoSave && this.updatedAndValid) {
          if (!this.inDialog && this.checkFields()) {
            // Dialogue to save or cancel changes
            this.inDialog = true;
            this.dialogSaveOrCancel().then(() => {
              this.createRef(this.contact);
              this.inDialog = false;
                  })
          } else if (!this.restoring && !this.inDialog) {
            this.restoreEdited();
            this.createRef(this.contact);
          }
        } else if (!this.inDialog) {
          if (this.cloneContact.id < 0) {
            this.clearRef();
          } else if (this.updated) {
            this.restoreEdited();
          }
          this.createRef(this.contact);
        }
      },
      beforeClose (): void {
        if (!this.closing) {
          this.closing = true;
          if (this.autoSave && this.updatedAndValid && this.checkFields()) {
            this.$emit('saveOrCancel');
            this.dialogSaveOrCancel();
          } else {
            if (this.autoSave && this.updated) {
              this.restoreEdited();
            }
            this.$emit('cancelled');
          }
          this.clearRef();
          }
      },

      setExtended (extended: Extended): void {
         this.$emit('extended', extended);
      },

      // eslint-disable-next-line
      isDisplayed (value: string): boolean {
        return true;
      },

      // eslint-disable-next-line
      required (value: string): boolean {
        return false;
      },

      // eslint-disable-next-line
      readOnly (value: string): boolean {
        return false;
      },

      save (): void {
        if (event != undefined) {
          event.stopPropagation();
        }
        this.saveLoading = true;
        this.saveFailed = false;
        if (this.checkFields()) {
          this.saveObj();
        } else {
        this.saveLoading = false;
          this.saveFailed = true;
        }
      },

      setUpdated (): void {
        const updated = (this.civiliteIdStatus != undefined && this.civiliteIdStatus.updated) ||
          (this.mailStatus != undefined && this.mailStatus.updated) ||
          (this.nomStatus != undefined && this.nomStatus.updated) ||
          (this.numeroStatus != undefined && this.numeroStatus.updated) ||
          (this.prenomStatus != undefined && this.prenomStatus.updated) ||
          (this.qualiteIdStatus != undefined && this.qualiteIdStatus.updated);
        if (updated != this.updated) {
          this.updated = updated;
          this.status.updated = updated;
          this.status.missing = this.hasMissing();
          if (!this.closing) {
            this.$emit('status', this.status);
          }
          this.$emit('updated', this.contact);
        }
      },

      setError (): void {
        const error = this.civiliteIdStatus.error ||
        this.mailStatus.error ||
        this.nomStatus.error ||
        this.numeroStatus.error ||
        this.prenomStatus.error ||
        this.qualiteIdStatus.error;
        if (error != this.error) {
          if (!error) {
            this.saveFailed = false;
          }
          this.error = error;
          this.status.error = error;
          if (!this.closing) {
            this.$emit('status', this.status);
          }
          this.$emit('updated', this.contact);
        }
      },

      // Clear non saved new objects when leaving
      clearRef (): void {
        if (this.clearAuto && this.refContact.id < 0) {
          storeContact.mContactDeleted(this.refContact.id);
        }
      },

      // Dialog to save or ignore changes when loosing focus or changing edited item
      dialogSaveOrCancel (): Promise<boolean> {
        return new Promise((resolve) => {
          if (!this.error) {
            Alerts.saveOrCancel()
              .then((result: boolean) => {
                if (result) {
                  this.saveObj();
                } else {
                  if (this.refContact.id <= 0) {
                    this.deleteObj();
                  } else {
                    this.restoreEdited();
                  }
                  this.$emit('cancelled');
                }
                resolve(result);
              })
          } else {
            this.restoreEdited();
          }
        })
      },

      // Save object and subobjects referenced by foreignClass keys
      saveObj (): void {
        this.saving = true;
        if (
          this.saveContact()
          ) {
          this.saving = false;
          this.saveLoading = false;
          this.contactSaving = false;
          this.createRef(this.refContact);
          this.$emit('updated', this.refContact);
          if (this.contact.id > 0) {
            this.$emit('saved', this.refContact);
          } else {
            this.updated = true;
          }
          if (this.autoClose) {
            this.saveFields();
            this.$emit('closeDialog');
          }
        } else {
          if (this.refContact.failed) {
          this.saveLoading = false;
            this.contactSaving = false;
            this.refContact.failed = false;
          }
        }
      },

      saveContact (): boolean {
        if (!this.refContact.compareContact(this.cloneContact)) {
          if (!this.contactSaving) {
            this.contactSaving = true;
          if (this.refContact.id > 0) {
            storeContact.updateContact(this.refContact)
              .then((data: Contact) => {
                if (!data.failed) {
                  this.refContact = storeContact.getContact(data.id);
                  this.cloneContact = data.cloneContact();
                } else {
                  this.refContact.failed = true;
                }
                this.saveObj();
              })
              .catch(() => {
                this.restoreEdited();
                this.contactSaving = false;
                this.saveLoading = false;
              })
          }
            if (this.refContact.id <= 0) {
              storeContact.createContact(this.refContact)
                .then((data: Contact) => {
                  if (!data.failed) {
                    this.refContact = storeContact.getContact(data.id);
                    this.cloneContact = data.cloneContact();
                  } else {
                this.refContact.failed = true;
                  }
                  this.saveObj();
                })
                .catch(() => {
                  this.restoreEdited();
                    this.contactSaving = false;
                })
            }
          }
          return false;
        } else {
          return true;
        }
      },

      // Delete object
      deleteObj (): void {
        if (this.refContact.id <= 0) {
          storeContact.mContactDeleted(this.refContact.id);
        } else {
          storeContact.deleteContact(this.refContact);
        }
      },

      statusCiviliteId (value: FieldStatus): void {
        this.civiliteIdStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusMail (value: FieldStatus): void {
        this.mailStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusNom (value: FieldStatus): void {
        this.nomStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusNumero (value: FieldStatus): void {
        this.numeroStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusPrenom (value: FieldStatus): void {
        this.prenomStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusQualiteId (value: FieldStatus): void {
        this.qualiteIdStatus = value;
        this.setUpdated();
        this.setError();
      },

      deleteContact(): void {
        this.$emit('deleteContact',  this.contact);
      },

    addContact(): void {
      this.$emit('addContact',  this.contact);
    },

      // Restore object
      restoreEdited (): void {
        if (this.cloneContact != undefined) {
          this.restoring = true;
          this.refContact.civiliteId = this.cloneContact.civiliteId;
          this.refContact.mail = this.cloneContact.mail;
          this.refContact.nom = this.cloneContact.nom;
          this.refContact.numero = this.cloneContact.numero;
          this.refContact.prenom = this.cloneContact.prenom;
          this.refContact.qualiteId = this.cloneContact.qualiteId;
          this.restoring = false;
        }
      },


    // Clone and clear edited
      createRef (value: Contact): void {
        this.clearRef();
        this.editContact = value;
        this.cloneContact = value.cloneContact();
        this.civiliteIdStatus.clear(value.id);
        this.mailStatus.clear(value.id);
        this.nomStatus.clear(value.id);
        this.numeroStatus.clear(value.id);
        this.prenomStatus.clear(value.id);
        this.qualiteIdStatus.clear(value.id);
        this.status.clear();
      },

    checkFields (): boolean {
        // @ts-expect-error : generated method
        if (this.isDisplayed('CIVILITE_ID') && this.$refs.CIVILITE_ID) this.$refs.CIVILITE_ID.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('MAIL') && this.$refs.MAIL) this.$refs.MAIL.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('NOM') && this.$refs.NOM) this.$refs.NOM.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('NUMERO') && this.$refs.NUMERO) this.$refs.NUMERO.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('PRENOM') && this.$refs.PRENOM) this.$refs.PRENOM.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('QUALITE_ID') && this.$refs.QUALITE_ID) this.$refs.QUALITE_ID.touch();
        return !this.error;
      },

      missing (value: string): boolean {
        return this.hasMissing(value);
      },

      hasMissing (value = ''): boolean {
        let missing = false;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'CIVILITE_ID') && this.isDisplayed('CIVILITE_ID') && this.$refs.CIVILITE_ID && this.$refs.CIVILITE_ID.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'MAIL') && this.isDisplayed('MAIL') && this.$refs.MAIL && this.$refs.MAIL.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'NOM') && this.isDisplayed('NOM') && this.$refs.NOM && this.$refs.NOM.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'NUMERO') && this.isDisplayed('NUMERO') && this.$refs.NUMERO && this.$refs.NUMERO.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'PRENOM') && this.isDisplayed('PRENOM') && this.$refs.PRENOM && this.$refs.PRENOM.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'QUALITE_ID') && this.isDisplayed('QUALITE_ID') && this.$refs.QUALITE_ID && this.$refs.QUALITE_ID.missing()) missing = true;
        return missing;
      },

      saveFields (): void {
        // @ts-expect-error : generated method
        if (this.isDisplayed('CIVILITE_ID') && this.$refs.CIVILITE_ID) this.$refs.CIVILITE_ID.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('MAIL') && this.$refs.MAIL) this.$refs.MAIL.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('NOM') && this.$refs.NOM) this.$refs.NOM.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('NUMERO') && this.$refs.NUMERO) this.$refs.NUMERO.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('PRENOM') && this.$refs.PRENOM) this.$refs.PRENOM.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('QUALITE_ID') && this.$refs.QUALITE_ID) this.$refs.QUALITE_ID.save();
      },

      getValue (field: string): string {
         if (field == 'CIVILITE_ID') return this.civiliteId.toString();
        else  if (field == 'MAIL') return this.mail.toString();
        else  if (field == 'NOM') return this.nom.toString();
        else  if (field == 'NUMERO') return this.numero.toString();
        else  if (field == 'PRENOM') return this.prenom.toString();
        else  if (field == 'QUALITE_ID') return this.qualiteId.toString();
        else return '';
      },

    // eslint-disable-next-line
    fieldUpdated (field: string, value: unknown): void {
      // To implement
    },

      setFocus (route: Route): boolean {
        let res = false;
        let first = '';
        const attribut = route ? route.attribut : '';
        this.fields.forEach(field => {
          // @ts-expect-error : generated method
          if (!res && this.isDisplayed(field) && !this.readOnly(field) && this.$refs[field].setFocus) {
            if (attribut == field) {
              // @ts-expect-error : generated method
              this.$refs[attribut].setFocus();
              res = true;
            } else if (first == '') {
              first = field;
            }
          }
        })
        // @ts-expect-error : generated method
        if (!res && first != '' && this.$refs[first] && this.$refs[first].setFocus) {
          // @ts-expect-error : generated method
          this.$refs[first].setFocus();
          res = true;
        }
        return res
      },

      closeDialog(): void {
        this.$emit('closeDialog')
      }
    },
  })
